import React from 'react';
const IconArrowOffsite = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 3H3V21H21V19H5V3Z" fill="#2D2E2E"/>
<path d="M12 3L10 5H17.59L9.29004 13.29L10.71 14.71L19 6.41V14L21 12V3H12Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconArrowOffsite;